import React, { useMemo } from 'react';

import { Link } from 'react-router-dom';

import { ReactComponent as LogoIcon } from '../../resources/icons/logo.svg';

import * as data from './links.json';
import { useAuthContext } from '../../contexts/authContext';

const linksString = JSON.stringify(data);
const links = JSON.parse(linksString).links;

type Link = {
  label: string;
  href: string;
  classname: string;
};

const Links: React.FC<{ links: Link[] }> = ({ links }) => {
  return (
    <ul className="flex items-center">
      {links.map((link: Link) => {
        return (
          <li key={link.label} className={`nav-item ${link.classname}`}>
            <Link className="nav-link" to={link.href}>
              {link.label}
            </Link>
          </li>
        );
      })}
    </ul>
  );
};

const Navbar: React.FC = () => {
  const { isAuthenticated, role } = useAuthContext();

  const LogoNavigationRoute = useMemo(() => {
    if (isAuthenticated) {
      return role === 'ADMIN' ? '/admin' : '/projects';
    }
    return '/';
  }, [isAuthenticated, role]);

  return (
    <nav>
      <div className="flex justify-between px-4 lg:px-16 py-4">
        <Link className="flex items-center font-bold" to={LogoNavigationRoute}>
          <div className="pb-3">
            <LogoIcon className="mr-1" />
          </div>
          Build Connect
        </Link>
        {/* <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarSupportedContent"
          aria-controls="navbarSupportedContent"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon" />
        </button> */}
        <div className="flex">
          {/* className="collapse navbar-collapse" id="navbarSupportedContent" for div upper*/}
          <Links
            links={
              isAuthenticated
                ? links.filter((l: any) => !l.hideIfAuthenticated)
                : links
            }
          />
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
